import { render } from "./CurrncyList.vue?vue&type=template&id=edf62180"
import script from "./CurrncyList.vue?vue&type=script&lang=js"
export * from "./CurrncyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__